import { CircularCheckbox } from 'components/CircularCheckbox'
import React, { PropsWithChildren } from 'react'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { SubtitleColorType } from 'service/list'
import { FormValues } from 'utils/type'

interface SubtitleColorProps {
  subtitleColorList: SubtitleColorType[] | []
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
}
export const SubtitleColor = ({
  subtitleColorList,
  watch,
  setValue,
  control,
}: PropsWithChildren<SubtitleColorProps>) => {
  const subtitleId = watch('subtitleId')
  return (
    <div className="flex flex-col gap-4">
      <p className="font-bold text-[18px] text-left">색상</p>
      <div className="grid grid-cols-2 md:grid-cols-4  gap-x-[22px] gap-y-[16px] ">
        {subtitleColorList?.map((subtitleColor, index) => {
          return (
            <>
              <div
                className="flex items-center gap-1 cursor-pointer"
                key={`subtitle_size_${index}`}
                onClick={() => {
                  if (subtitleId !== 1) {
                    setValue('subtitleColorId', subtitleColor.id)
                  }
                }}
              >
                <Controller
                  render={({ field }) => (
                    <CircularCheckbox
                      {...field}
                      id={index}
                      checked={watch('subtitleColorId') === subtitleColor.id}
                      onChange={() => {}}
                    />
                  )}
                  name="subtitleColorId"
                  control={control}
                />
                <img src={subtitleColor?.imagePath} alt="" />
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}
